import { createFileRoute } from '@tanstack/react-router';
import AnalyticsPage from '../../../../Containers/AnalyticsPage';

export const Route = createFileRoute('/(main)/_layout/dashboards/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="analytics-page">
      <AnalyticsPage />
    </div>
  );
}
